<template>
  <div class="video-box" :style="`padding: ${padding};`">
    <div class="video-in">
      <div class="video-kv" v-show="liveState!==2">
        <img :src="poster" alt="">
        <div class="count-down" v-show="liveState!==2">
          <div v-if="time>0">
            <span>距离直播开始：</span>
            <van-count-down :time="time" @finish="finish" format="DD 天 HH 时 mm 分 ss 秒" />
          </div>
          <span v-else>直播即将开始</span>
        </div>
      </div>
      <div class="video-pv">
        <van-icon name="friends-o"></van-icon><span>{{$handleUnit(pv)}}</span>
      </div>
      <video
        id="my-video"
        class="video-js vjs-default-skin vjs-big-play-centered"
        controls
        :webkit-playsinline="true"
        :playsinline="true"
        disablePictureInPicture
        :poster="poster"
        :width="width"
        preload="auto"
      >
      </video>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js';
import 'videojs-contrib-hls';
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      player: null,
      isTrue: true,
      timer: null,
      time: null,
      liveAddress: []
    }
  },
  computed: {
    ...mapGetters(['liveState'])
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    isPlay: {
      type: Boolean,
      default: false
    },
    pv: {
      typeof: Number || String,
      default: 0
    },
    liveInfo: {
      type: Object,
      default: () => {
        return {
          live: {},
          liveStream: {}
        }
      }
    },
    poster: {
      type: String,
      default: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_d4599d99b2ae40de8f04dd39982f2c38.jpg'
    },
    padding: {
      type: String,
      default: ''
    }
  },
  watch: {
    poster(n) {
      if (!this.isTrue) {
        document.getElementsByClassName('vjs-poster')[0].style = `background: url(${n});`
      }
    },
    liveInfo(n) {
      const time = new Date().getTime()
      if (this.isTrue) {
        this.$nextTick(() => {
          clearInterval(this.timer)
          this.getVideo();
          this.time = this.liveInfo.live.livetime * 1000 - time
        });
        this.isTrue = false
      } else {
        clearInterval(this.timer)
        this.$store.commit('state/SET_LIVESTATE', 1)
        this.isState()
        if (time >= this.liveInfo.live.livetime * 1000) {
          this.timer = setInterval(() => {
            this.isState()
          }, 5000)
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    // 倒计时结束
    finish() {
      const time = new Date().getTime()
      if (this.liveState === 1) {
        this.isState()
        if (time >= this.liveInfo.live.livetime * 1000) {
          this.time = -1
          this.timer = setInterval(() => {
            this.isState()
          }, 5000)
        }
      }
    },
    getVideo() {
      this.player = videojs('my-video', {
        bigPlayButton: true, // 显示播放按钮
        textTrackDisplay: false,
        posterImage: true,
        errorDisplay: false,
        controlBar: true // 显示控件
      }, that => {
        this.player.on('play', () => {
          this.$emit('update:isPlay', true)
        });
        this.player.on('error', () => {
          this.liveAddress.shift()
          if (!this.liveAddress.length) {
            console.log('即将开始')
            this.$store.commit('state/SET_LIVESTATE', 1)
          } else {
            this.player.src(this.liveAddress[0])
          }
        });
        const time = new Date().getTime()
        this.$store.commit('state/SET_LIVESTATE', 1)
        this.isState()
        if (time >= this.liveInfo.live.livetime * 1000) {
          this.timer = setInterval(() => {
            this.isState()
          }, 5000)
        }
      })
    },
    isState() {
      if (this.liveState === 1) {
        this.liveAddress = []
        const data = this.liveInfo.liveStream
        for (let key in data) {
          if (key.indexOf('Address') !== -1) {
            if (data[key]) {
              this.liveAddress.push({ src: data[key] })
            }
          }
        }
        if (!this.liveAddress.length) {
          console.log('即将开始')
          this.$store.commit('state/SET_LIVESTATE', 1)
          return
        }
        this.player.src(this.liveAddress[0])
        if (this.liveAddress.length) {
          this.$store.commit('state/SET_LIVESTATE', 2)
        }
      } else {
        clearInterval(this.timer)
      }
    },
    play(arr) {
      this.player.play(arr)
    },
    pause() {
      this.player.pause()
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
      this.player = null
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss" scoped>
  .video-box {
    // position: absolute;
    width: 100%;
    height: 100%;
    // top: 0;
    // left: 0;
    box-sizing: border-box;
    .video-in {
      display: flex;
      width: 100%;
      height: 100%;
      position: relative;
    }
    #my-video {
      margin: auto;
      width: 100%;
      height: 100%;
    }
    ::v-deep .video-js .vjs-big-play-button {
        font-size: 6em !important;
        color: rgba(255, 255, 255, .5) !important;
        background: none;
        border: none;
      }
  }
  .video-kv {
    width: 100%;
    height: 100%;
    z-index: 999;
    position: absolute;
    background: #fff;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 100%;
    }
    ::v-deep .count-down {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: .02rem .1rem;
      color: orange !important;
      background-color: rgba(0, 0, 0, .5);
      box-sizing: border-box;
      .van-count-down {
        display: inline;
        color: orange !important;
      }
    }
  }
  .video-pv {
    position: absolute;
    right: .1rem;
    top: .06rem;
    font-size: .16rem;
    color: #fff;
    line-height: .3rem;
    border-radius: .15rem;
    z-index: 9999;
    // background-color: rgba(0, 0, 0, .5);
  }
  ::v-deep .vjs-poster {
    background-size: 100% 100% !important;
  }
</style>
